import React, {Component} from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import assets from "../../util/assets"

export default class TipResponseModal extends Component {
  render() {
    return (
      <Modal
        isOpen={this.props.showTipResponseModalFlag}
        toggle={() => this.props.hideTipResponseModal()}
        centered
        contentClassName="modalContentOfTipResponse w-75"
      >
        <ModalHeader
          toggle={() => this.props.hideTipResponseModal()}
        ></ModalHeader>
        <ModalBody style={{ padding: "160px 20px" }}>
          <img src={assets.thank_you_hand_white_bg} style={{ height: "83px", width: "110px" }} />
          <p className="thankYouText">Thank you!</p>
          <p className="forYourContributionText">
            {this.props.tipMessage && this.props.tipMessage}
          </p>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    );
  }
}
